// extracted by mini-css-extract-plugin
module.exports = {"inputlabel":"InputTemplate_inputlabel__2yOd0","label":"InputTemplate_label__1e3ZR"};